import { z } from 'zod';
import { AiProvenanceSchema } from '../../shared/ai-provenance';
/**
 * Transcribe Audio Response Schema
 *
 * Request is multipart/form-data with an 'audio' file field,
 * so no Zod request schema is needed.
 */ export const TranscribeAudioResponseSchema = z.object({
    text: z.string(),
    aiProvenance: AiProvenanceSchema.optional()
});

//# sourceMappingURL=transcribe-audio.schema.js.map